import Alpine from "alpinejs";

Alpine.data("priceRangeActiveFilters", () => ({
  priceFilters: [],
  get hasPriceFilters() {
    return this.priceFilters.length > 0;
  },
  init() {
    const currentUrl = new URL(window.location.href);

    for (const [key, value] of currentUrl.searchParams.entries()) {
      let match = key.match(/^(.+)\.(gte|lte)$/);

      if (match) {
        let priceFilterBaseParamName = match[1];

        if (
          !this.priceFilters.some(
            (filter) => filter.name === priceFilterBaseParamName,
          )
        ) {
          let label = priceFilterBaseParamName.replace("filter.v.", "");

          let gte = window.Shopify.helpers.asMoney(
            parseFloat(
              currentUrl.searchParams.get(`${priceFilterBaseParamName}.gte`),
            ),
          );
          let lte = window.Shopify.helpers.asMoney(
            parseFloat(
              currentUrl.searchParams.get(`${priceFilterBaseParamName}.lte`),
            ),
          );

          let removeFilterUrl = new URL(window.location.href);
          removeFilterUrl.searchParams.delete(
            `${priceFilterBaseParamName}.gte`,
          );
          removeFilterUrl.searchParams.delete(
            `${priceFilterBaseParamName}.lte`,
          );

          this.priceFilters.push({
            name: priceFilterBaseParamName,
            label: `${label} (${gte} - ${lte})`,
            removeUrl: removeFilterUrl.toString(),
          });
        }
      }
    }
  },
}));
